import FeedbacksList from './FeedbacksList';

export default FeedbacksList;
